<template>
  <div class="customer-voice-box">
    <img src="./img/customer_topic.png" class="topic-img" alt="">
    <!--<p class="customer-voice-title">お客様の声</p>-->
   <!-- <div class="customer-voice-container">
      <div class="customer-voice-content" v-for="voice in customerVoices" :key="voice">
        <div class="customer-voice-content-head">
          <div class="customer-profile">{{ voice.profile }}</div>
          <div class="voice-title">{{ voice.title }}</div>
        </div>
        <div class="voice-content">{{ voice.content }}</div>
      </div>
    </div> -->
    <div class="customer-voice-container">
      <div class="shop-name">
        <!-- <p class="shop-name-text">小倉北店</p> -->
      </div>
      <!-- 0204 voice-groupを追加、voice-boxのdiv名を変更、class voice-left、voice-rightを追加 -->
      <div class="voice-group">
      <div class="voice-box-1 voice-left">
          <div class="customer-voice-content-head">
             <!-- <img src="./img/title-head-1.png" class="icon"> -->
              <img src="./img/title_head-2.jpg" class="icon">
          </div>
          <div class="customer-voice-container">
            <p class="voice-text">ハイフを続けて受けたくて他のサロンも行きましたが、こちらのマシーンは痛みもなく、なのに私の身体には効果大！<br>
              店員さんも感じがよくコロナ対策も徹底してらっしゃいます。エンリケさんが好きでYouTubeなどみていたこともあり満足しました。<br>
              <span class="text-strong">マイペースで好きな所に打てる</span>ので気を使わなくていいですよ。通わせて頂きます。有難うございました。</p>
          </div>
      </div>
      <!-- <div class="shop-name">
        <p class="shop-name-text">仙台店</p>
      </div> -->
      <div class="voice-box-1 voice-right">
          <div class="customer-voice-content-head">
              <!-- <img src="./img/title-head-2.png" class="icon"> -->
              <img src="./img/title_head-1.jpg" class="icon">
          </div>
          <div class="customer-voice-container">
            <p class="voice-text">初めてのセルフエステで、ラジオ波って？キャビテーションって？という状態でしたが、スタッフさんが丁寧に、何が何に効果あるかを説明してくださいました。<br>
              施術前に機械の使い方を動画でみて、いざ施術。私は肩こりを改善したかったので、主にラジオ波を肩周りにあててみました。<br>
              ほかほかあたたまって気持ちよく、<span class="text-strong">コリもほぐれた気がします。</span>施術後肩が軽くなりました。ありがとうございました。</p>
          </div>
      </div>
      <div class="shop-name">
        <!--<p class="shop-name-text">天文館店</p>-->
      </div>
      </div>
      <div class="voice-group">
      <div class="voice-box-2 voice-left">
          <div class="customer-voice-content-head">
            <!-- <img src="./img/title-head-3.png" class="icon"> -->
            <img src="./img/title_head-4.jpg" class="icon">
          </div>
          <div class="customer-voice-container">
            <p class="voice-text">初めてのセルフエステ。ドキドキしてワクワクする空間でした。店内が可愛い！店員さんも細かいところまで気を配ってくれる接客上手な方でした。<br>
初めてのハイフでしたが、まず、ハイフ終了後に<span class="text-strong">肌のトーンが上がった</span>のはすぐ分かりました。
ハイフから2日後にハリがでてきて3日目から物凄く肌の調子が上がりました！<span class="text-strong">ツヤツヤむき卵</span>みたいです。<br>
また行きます。ありがとうございました！</p>
          </div>
      </div>
      <!-- <div class="shop-name">
        <p class="shop-name-text">宮崎店</p>
      </div> -->
      <div class="voice-box-2 voice-right">
          <div class="customer-voice-content-head">
              <!-- <img src="./img/title-head-4.png" class="icon"> -->
              <img src="./img/title_head-3.jpg" class="icon">
          </div>
          <div class="customer-voice-container">
            <p class="voice-text">初めてのセルフエステで不安でしたが、スタッフさんの分かりやすい説明で安心して施術できました！<br>
              施術直後はもちろん<span class="text-strong">翌日にはもっと効果を感じた</span>のでまた伺いたいと思います！<br>
ありがとうございました！</p>
          </div>
      </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'CustomerVoice',
  data: function(){
        return {
          customerVoices:[
            {
              profile:'女性',
              title:'当てたいところに当てられる',
              content:`好きな場所に好きに当てられるのは本当に魅力的。
私は内ももだけ当てたかったので、重点的に内ももに当てることができました。
自分の体のことは自分が良くわかってるので、思い通りに施術できました。
その結果、気になっていた内ももがスリムに。
自信を持ってスキニーを履くことができました。`
            },{
              profile:'女性',
              title:'自分のペースでできる',
              content:`強さも施術のタイミングも自分で選べるのがすごく魅力的でした。
エステに到着して服を脱いでから、あ！やっぱここやりたい！って思って、その場で施術場所変更。
セルフエステエンリケには、全身どこでも組み合わせOKのプランがあるのでこんなに自由！
普通のエステだとそんなことあんまりできないから。
この自由さに惹かれて、今は定額プランで通っています♪`
            },{
              profile:'女性',
              title:'何にせよ早い！',
              content:`今日は彼氏のお母さんに会う大事な日。なのに、私すっごい顔がむくんでて。
どうしよう、こんな顔じゃ会えないって思ってたところで、このセルフエステを発見。
ハイフのフェイシャルが2,980円！しかも、10分かからない。
仕事のお昼休憩の時間にこっそり行ったけど、こんなに早く終わると思わなかったので本当に驚きました。
しかも、顔は超スッキリ！彼のお母さんにも万全の状態で会えて、今は定額プランで通っています♪すっかりお気に入り！`
            },{
              profile:'女性',
              title:'機械がすごい',
              content:`セルフエステって、いろんな人が使うし衛生面とか大丈夫かな…？
うまく使えるかな…？とかすっごい不安ばかりでした。
でも実際行ってみたら、機械は自動消毒機能がついてるし、使い方も機械の周りに使い方が書いてあるPOPがいっぱいあったし、
店員さんも丁寧だしで簡単に使えました！こんな機械みたことない！！手軽に行けるし、また行こう！ってなりました。`
            },

          ]
        }
    },
}
</script>

<style scoped>
  .customer-voice-box{
    background-color: var(--main-color);
    text-align: center;
    padding: 20px;
  }

  .customer-voice-title{
    font-size: 24px;
    font-weight:600;
    width: 5em;
    background-color: white;
    color: var(--main-color);
    left:0;
    right:0;
    margin:auto;

    padding:0.8em 4em;
  }
  
  
  
  .voice-text{
    padding:20px 0;
    line-height: 1.5em;
    border-top:solid 2px var(--main-color);
    width:80%;
    margin:10px auto;
    text-align: left;
    text-align: justify; /* 両端揃え */
   text-justify: inter-ideograph; /* 両端揃えの種類 */
    padding-bottom: 30px;
    
  }

   /* PC表示 */
  @media screen and (min-width:821px){

    .customer-voice-content{
      min-width: 30vw;
      max-width: 30vw;
      min-height: 25vw;
      background-color: white;
      border-radius:25px;
      padding:2.5% 3.5%;
      margin: 2vw;
    }

    .customer-voice-title{
      font-size: 24px;
      width: 5em;
      background-color: white;
      color: var(--main-color);
      left:0;
      right:0;
      margin:auto;

      padding:0.8em 4em;
    }

    .customer-voice-content-head{
      display:inline-block;
      align-items: flex-end;
      padding-top:20px;
      padding-bottom:6px;
    }

    .voice-title{
      font-size: 1.2rem;
      font-weight: 600;
      white-space: nowrap;
    }

    .customer-profile{
      font-size: 1rem;
      color: var(--main-color);
      margin: 10px 4% 0 0;
      white-space: nowrap;
      font-weight: 600;
    }

    .voice-content{
      font-size: 1rem;
      text-align: left;
      line-height: 1.5em;
    }

    .topic-img{
      width:30%;
      padding-top:30px;
      padding-bottom:16px;
    }

    .icon{
      width:100%;
      margin-left:24px;
    }

    .voice-group{
      width:100%;
      height:auto;
      display:flex;
    }

    .voice-box-1, .voice-box-2{
      margin:0 auto;
      overflow-x:hidden;
    }

  .voice-box-1{
    background:#fff;
    margin:30px auto;
    border-radius:16px;
    width:42%;
    height:auto;
  }

  .voice-box-2{
    background:#fff;
    margin:30px auto;
    border-radius:16px;
    width:42%;
    height:auto;
  }

  .voice-left{
    margin-right:30px;
  }

  .customer-voice-container{
    width: 80%;
    /*display:flex;
    flex-wrap:wrap;*/

    justify-content: center;
    left:0;
    right:0;
    margin:auto;
   /* background:#fff;*/
  }

  }

  /* スマホ表示 */
  @media screen and (max-width:820px){

    .shop-name{
      width:100%;
      text-align: center;
    }

    .shop-name-text{
      font-size:1.4em;
      font-weight:600;
      color:var(--main-color);
      background-color:#fff;
      padding:10px;
    }

    /*  ↓ここwidth追加  */
    

    .icon{
      width:77%;
      padding:10px 40px;
      padding-top:20px;
  }

     .topic-img{
      width:56%;
      margin-top:10px;
      margin-bottom:30px;
    }

    .customer-voice-content{
      width: 100%;
      min-height: 25vw;
      background-color: white;
      border-radius:25px;
      padding: 5% 7%;
      margin: 2vw;
      line-height: 1.5em;
    }

    .customer-voice-title{
      font-size: 18px;
      width: 5em;
      background-color: white;
      color: var(--main-color);
      left:0;
      right:0;
      margin:1em auto;

      padding: 0.8em 4em;
      
    }

    .customer-voice-content-head{
      display:flex;
      align-items: flex-end;
      margin-bottom: 0.5em;
      vertical-align: text-bottom;
    }

    .voice-title{
      font-size: 4vw;
      font-weight: 600;
      white-space: nowrap;
    }

    

    .customer-profile{
      font-size: 3vw;
      font-weight: 600;
      color: var(--main-color);
      margin: 10px 4% 0 0;
      white-space: nowrap;
    }

    .voice-content{
      font-size: 13px;
      text-align: left;
    }

    .text-strong{
      font-weight:600;
      background:linear-gradient(transparent 70%, yellow 30%);
    }

    .voice-box-1{
      background:#fff;
      margin:30px auto;
      border-radius:16px;
      width:100%;
      height:auto;
  }
  
    .voice-box-2{
      background:#fff;
     margin:30px auto;
     border-radius:16px;
     width:100%;
      height:auto;
  }

  .customer-voice-container{
    width: 85vw;
    /*display:flex;
    flex-wrap:wrap;*/

    justify-content: center;
    left:0;
    right:0;
    margin:auto;
   /* background:#fff;*/
  }

  }
</style>